import script from "./Siding04Accessories.vue?vue&type=script&setup=true&lang=js"
export * from "./Siding04Accessories.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__